// Reactive state for the cookie banner and the preferences dialog. The
// cookie itself and the tags live in lib/tracking.ts.

import { readConsent, saveConsent, type ConsentState } from '../tracking';

class ConsentStore {
  /** The stored choice; null until the visitor has chosen. */
  value = $state<ConsentState | null>(typeof document !== 'undefined' ? readConsent() : null);
  /** The preferences dialog is open. */
  preferencesOpen = $state(false);

  get decided() {
    return this.value !== null;
  }

  acceptAll() {
    this.choose({ analytics: true, marketing: true });
  }

  rejectAll() {
    this.choose({ analytics: false, marketing: false });
  }

  choose(choice: { analytics: boolean; marketing: boolean }) {
    this.value = saveConsent(choice);
    this.preferencesOpen = false;
  }

  openPreferences() {
    this.value = readConsent();
    this.preferencesOpen = true;
  }
}

export const consent = new ConsentStore();

/** Open the cookie preferences (footer links, cookie policy, settings page). */
export function openConsentPreferences(): void {
  consent.openPreferences();
}
